import React, { PropsWithChildren } from 'react';
import useStyles from './styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Box from '@material-ui/core/Box';
import DialogContent from '@material-ui/core/DialogContent';
import { useTranslation } from 'react-i18next';

export interface P {
  isOpen: boolean;
  onClose?: () => void;
  onEdit?: () => void;
}
export type Props = PropsWithChildren<P>;

const EditFormModal: React.FC<Props> = ({ isOpen, onClose, children, onEdit }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog maxWidth="sm" open={isOpen} fullWidth>
      <DialogContent>
        <Box pt={2}>
          {typeof children === 'string' ? (
            <p dangerouslySetInnerHTML={{ __html: children }} />
          ) : (
            children
          )}
        </Box>

        <div className={classes.buttonWrapper}>
          <Button onClick={onClose} variant="contained" className={classes.button}>
            {t('editFormModal_ok')}
          </Button>

          <Button onClick={onEdit} variant="contained" color="primary" className={classes.button}>
            {t('editFormModal_edit')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default EditFormModal;
